import { useEffect, useState } from 'react';
import { Printer, Filter, Search, RefreshCw } from 'lucide-react';
import api from '../services/api';

export default function ReporteEvidenciasPage() {
  const [areas, setAreas] = useState([]);
  const [filters, setFilters] = useState({ areaId: '', from: '', to: '' });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    api.get('/areas').then(r => setAreas(r.data)).catch(() => {});
  }, []);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.areaId) params.areaId = filters.areaId;
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
      const res = await api.get('/dashboard/report-fotografico', { params });
      setData(res.data.data);
      setSearched(true);
    } catch { alert('Error al cargar el reporte'); }
    finally { setLoading(false); }
  };

  const handleReset = () => { setFilters({ areaId: '', from: '', to: '' }); setData([]); setSearched(false); };

  const imgBase = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:4000';

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .foto-report-content, .foto-report-content * { visibility: visible; }
          .foto-report-content { position: absolute; left: 0; top: 0; width: 100%; }
          .no-print { display: none !important; }
        }
      `}</style>

      <div className="no-print" style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1a2f6b', margin: 0 }}>Reporte de evidencias</h1>
        <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>Fotos antes/después de solicitudes completadas</p>
      </div>

      {/* Filtros */}
      <div className="no-print" style={{ background: 'white', borderRadius: 16, boxShadow: '0 2px 16px rgba(26,47,107,0.07)', border: '1px solid #e2e8f0', padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 14 }}>
          <Filter size={14} color="#2563eb" />
          <span style={{ fontWeight: 700, color: '#1a2f6b', fontSize: 14 }}>Filtros</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 16 }}>
          <div>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Área</label>
            <select value={filters.areaId} onChange={e => setFilters({ ...filters, areaId: e.target.value })}
              style={{ width: '100%', border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 10px', fontSize: 13, fontFamily: 'inherit', outline: 'none' }}>
              <option value="">Todas</option>
              {areas.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Desde</label>
            <input type="date" value={filters.from} onChange={e => setFilters({ ...filters, from: e.target.value })}
              style={{ width: '100%', boxSizing: 'border-box', border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 10px', fontSize: 13, fontFamily: 'inherit', outline: 'none' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Hasta</label>
            <input type="date" value={filters.to} onChange={e => setFilters({ ...filters, to: e.target.value })}
              style={{ width: '100%', boxSizing: 'border-box', border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 10px', fontSize: 13, fontFamily: 'inherit', outline: 'none' }} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <button onClick={fetchReport} disabled={loading}
            style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#2563eb', color: 'white', border: 'none', borderRadius: 10, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
            {loading ? <RefreshCw size={14} /> : <Search size={14} />}
            {loading ? 'Buscando...' : 'Buscar'}
          </button>
          <button onClick={handleReset}
            style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'white', color: '#64748b', border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
            <RefreshCw size={14} /> Limpiar
          </button>
          {data.length > 0 && (
            <button onClick={() => window.print()}
              style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#7c3aed', color: 'white', border: 'none', borderRadius: 10, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
              <Printer size={14} /> Imprimir / Guardar PDF
            </button>
          )}
        </div>
      </div>

      {/* Resultados */}
      <div className="foto-report-content">
        {searched && data.length === 0 && (
          <p style={{ color: '#94a3b8', textAlign: 'center', padding: 24 }}>No hay solicitudes completadas con evidencias en el rango seleccionado.</p>
        )}

        {data.map(r => {
          const antes = r.evidencias.filter(ev => ev.tipo === 'ANTES');
          const despues = r.evidencias.filter(ev => ev.tipo === 'DESPUES');
          return (
            <div key={r.id} style={{ border: '1px solid #e2e8f0', borderRadius: 16, padding: 20, marginBottom: 16, background: 'white', pageBreakInside: 'avoid' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
                <div>
                  <span style={{ fontFamily: 'monospace', fontSize: 12, color: '#2563eb', fontWeight: 700 }}>{r.folio}</span>
                  <p style={{ margin: '2px 0 0', fontSize: 15, fontWeight: 700, color: '#1e293b' }}>{r.description}</p>
                </div>
                <div style={{ fontSize: 11, color: '#64748b', textAlign: 'right' }}>
                  <div>{r.area?.name}</div>
                  <div>{r.assignedTo?.name || 'Sin asignar'}</div>
                  <div>{r.closedAt ? new Date(r.closedAt).toLocaleDateString('es-MX') : ''}</div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div>
                  <p style={{ margin: '0 0 8px', fontSize: 11, fontWeight: 700, color: '#ea580c', textTransform: 'uppercase' }}>Antes</p>
                  {antes.length === 0 && <p style={{ fontSize: 12, color: '#94a3b8' }}>Sin fotos</p>}
                  {antes.map(ev => (
                    <div key={ev.id} style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                      {ev.fotos.map(f => (
                        <img key={f.id} src={`${imgBase}${f.url}`} alt="antes" style={{ width: 110, height: 110, objectFit: 'cover', borderRadius: 8 }} />
                      ))}
                    </div>
                  ))}
                </div>
                <div>
                  <p style={{ margin: '0 0 8px', fontSize: 11, fontWeight: 700, color: '#16a34a', textTransform: 'uppercase' }}>Después</p>
                  {despues.length === 0 && <p style={{ fontSize: 12, color: '#94a3b8' }}>Sin fotos</p>}
                  {despues.map(ev => (
                    <div key={ev.id} style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                      {ev.fotos.map(f => (
                        <img key={f.id} src={`${imgBase}${f.url}`} alt="despues" style={{ width: 110, height: 110, objectFit: 'cover', borderRadius: 8 }} />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}

        {!searched && !loading && (
          <div className="no-print" style={{ textAlign: 'center', padding: '40px 16px', color: '#94a3b8' }}>
            <Filter size={32} color="#e2e8f0" style={{ margin: '0 auto 10px', display: 'block' }} />
            <p style={{ margin: 0, fontSize: 13 }}>Selecciona filtros y haz clic en <strong>Buscar</strong></p>
          </div>
        )}
      </div>
    </div>
  );
}